var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#B8EBF5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FAFAFA",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.728 39.016C37.728 41.0427 37.1627 42.6 36.032 43.688C34.9227 44.7547 33.3227 45.288 31.232 45.288C29.824 45.288 28.5973 45.224 27.552 45.096C26.5067 44.9893 25.696 44.8293 25.12 44.616V41.224C25.888 41.3733 26.6773 41.4907 27.488 41.576C28.32 41.64 29.216 41.672 30.176 41.672C31.52 41.672 32.4693 41.4693 33.024 41.064C33.6 40.6373 33.888 39.9333 33.888 38.952C33.888 37.9707 33.6213 37.288 33.088 36.904C32.576 36.52 31.5627 36.328 30.048 36.328C29.216 36.328 28.4693 36.36 27.808 36.424C27.168 36.4667 26.56 36.5413 25.984 36.648V24.936H36.448V28.392H29.824V33.256C30.2933 33.2133 30.7093 33.1813 31.072 33.16C31.456 33.1387 31.8187 33.128 32.16 33.128C34.144 33.128 35.5627 33.608 36.416 34.568C37.2907 35.5067 37.728 36.9893 37.728 39.016Z",
    fill: "#0B4F5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC5);
export default __webpack_public_path__ + "static/media/C5.f4c71149fb709f96ab7d99e800774b2c.svg";
export { ForwardRef as ReactComponent };